import React from 'react'
import { Grid } from '@mui/material'
import InputCustom from '../../../../atoms/input/InputCustom'
import styles from '../index.module.scss'
import GoogleAddressInput from '../../../../atoms/input/GoogleAddressInput'

const VanueModal = ({ data, setData }) => {
	const handleCeremonyPlaceSelected = (placeData) => {
		setData((prev) => ({
			...prev,
			ceremonyLocation: placeData.formattedAddress,
		}))
	}

	const handleReceptionPlaceSelected = (placeData) => {
		setData((prev) => ({
			...prev,
			receptionLocation: placeData.formattedAddress,
		}))
	}

	const handleMainCharacter1PlaceSelected = (placeData) => {
		setData((prev) => ({
			...prev,
			mainCharacter1GettingReadyLocation: placeData.formattedAddress,
		}))
	}

	const handleMainCharacter2PlaceSelected = (placeData) => {
		setData((prev) => ({
			...prev,
			mainCharacter2GettingReadyLocation: placeData.formattedAddress,
		}))
	}

	return (
		<>
			<div className={styles.header}>
				<h3>Venue & Locations</h3>
			</div>
			<div className={`${styles.formWrp} ${styles.venueForm}`}>
				<Grid container spacing={1.5}>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="ceremonyLocation"
								className={styles.label}
							>
								Ceremony Location
							</label>
							<GoogleAddressInput
								data-cy="ceremonyLocation"
								placeholder="Enter full address"
								name="ceremonyLocation"
								value={data?.ceremonyLocation || ''}
								setDataFunction={setData}
								data={data}
								onPlaceSelected={handleCeremonyPlaceSelected}
								required={true}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="receptionLocation"
								className={styles.label}
							>
								Reception Location
							</label>
							<GoogleAddressInput
								data-cy="receptionLocation"
								placeholder="Enter full address"
								name="receptionLocation"
								value={data?.receptionLocation || ''}
								setDataFunction={setData}
								data={data}
								onPlaceSelected={handleReceptionPlaceSelected}
								required={true}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="mainCharacter1GettingReadyLocation"
								className={styles.label}
							>
								MainCharacter1 Getting Ready Location
							</label>
							<GoogleAddressInput
								data-cy="mainCharacter1GettingReadyLocation"
								placeholder="Enter full address"
								name="mainCharacter1GettingReadyLocation"
								value={
									data?.mainCharacter1GettingReadyLocation ||
									''
								}
								setDataFunction={setData}
								data={data}
								onPlaceSelected={
									handleMainCharacter1PlaceSelected
								}
								required={true}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="mainCharacter2GettingReadyLocation"
								className={styles.label}
							>
								MainCharacter2 Getting Ready Location
							</label>
							<GoogleAddressInput
								data-cy="mainCharacter2GettingReadyLocation"
								placeholder="Enter full address"
								name="mainCharacter2GettingReadyLocation"
								value={
									data?.mainCharacter2GettingReadyLocation ||
									''
								}
								setDataFunction={setData}
								data={data}
								onPlaceSelected={
									handleMainCharacter2PlaceSelected
								}
								required={true}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="venueBookedTimeRange"
								className={styles.label}
							>
								Venue Booked Time Range
							</label>
							<InputCustom
								type="text"
								name="venueBookedTimeRange"
								id="venueBookedTimeRange"
								placeholder="e.g., 2:00 PM - 10:00 PM"
								className=""
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="venueSetupTime"
								className={styles.label}
							>
								Venue Setup Time
							</label>
							<InputCustom
								type="text"
								name="venueSetupTime"
								id="venueSetupTime"
								placeholder="e.g., 12:00 PM - 2:00 PM"
								className=""
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="guestArrivalTime"
								className={styles.label}
							>
								Guest Arrival Time
							</label>
							<InputCustom
								type="text"
								name="guestArrivalTime"
								id="guestArrivalTime"
								placeholder="e.g., 3:30 PM"
								className=""
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 6 }}>
						<div className={styles.formField}>
							<label
								htmlFor="guestArrivalTime"
								className={styles.label}
							>
								Guest Departure Time
							</label>
							<InputCustom
								type="text"
								name="guestDepartureTime"
								id="guestDepartureTime"
								placeholder="e.g., 9:30 PM"
								className=""
							/>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default React.memo(VanueModal)
